import React from 'react';
import { Switch } from '@/components/DesignSystem/AtomicComponents';
import { useSSRSelector } from '@/redux/ssrStore';
import { TABS_DATA } from 'src/constants/order';

export function OrderHeaderView() {
  const theme = useSSRSelector((state) => state.storeReducer.store?.theme);

  return (
    <div
      style={{
        margin: '10px auto 15px',
        width: '100%',
      }}
    >
      <Switch
        tabsData={TABS_DATA}
        roundness={theme?.roundness}
        fluid={true}
        backgroundColor={theme?.colors?.primary_color}
      />
    </div>
  );
}

export default OrderHeaderView;
